import { GridGroup as SharedGridGroup } from '@cx-web/components/page-template/GridGroup';
import { useUIConfig } from '@cx-web/ui-shell/ui-config-context';
import { captureException } from '@sentry/react-router';

import { type ComponentLoaderContext } from '~/types/component-loader-context';
import { type GridGroupComponentProps } from '~/types/template';

// RR7 glue for the shared GridGroup (NGF-6507). The rendering logic lives once in
// @cx-web/components/page-template/GridGroup (consumed by RR7 atlas + atlas-astro); this app only
// resolves request context its own way: `resourcesUrl` from useUIConfig() and `onError` from Sentry's
// captureException. renderComponents spreads ComponentLoaderContext (+ the loader-threaded gtmId) onto
// these props, so everything the shared component needs is already present.
export const GridGroup = (
  props: GridGroupComponentProps &
    ComponentLoaderContext & {
      // NGF-6128: gtmId is merged onto props by renderComponents (threaded from the loader response).
      gtmId: string;
    },
) => {
  const { resourcesUrl } = useUIConfig();

  return <SharedGridGroup {...props} onError={captureException} resourcesUrl={resourcesUrl} />;
};
